<template>
    <div class="info_container">
        <button class="open_button fa fa-info-circle" @click.stop="info_visible = true" :disabled="disabled" title="Дополнительная информация"></button>
        <!-- начало блока всплывающей подсказки -->
        <div class="modal_wrapper" v-show="info_visible">
            <div class="modal_container">
                <button class="close_button" @click="info_visible = false">X</button>
                <slot></slot>
            </div>
        </div>
        <!-- конец блока всплывающей подсказки -->
    </div>
</template>

<script>
export default {
    name: "Info",
    props: ["disabled"],
    data() {
        return {
            info_visible: false,
        };
    },
};
</script>

<style scoped>
.info_container {
    padding: 5px;
    margin: 0px;
    display: flex;
}

.info_container > .open_button {
    border: none;
    background: none;
    color: #fc5a0a;
    cursor: pointer;
    font-size: 14pt;
    padding: 0px;
    margin: auto;
    opacity: 0.8;
}

.info_container > .open_button:hover {
    opacity: 1;
}

.info_container > .modal_wrapper {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: rgba(0, 0, 0, 0.1);
    display: flex;
}

.info_container > .open_button:disabled {
    color: lightgray;
}

.info_container > .modal_wrapper > .modal_container {
    margin: auto;
    box-shadow: 0px 0px 12px 2px grey;
    border-radius: 5px;
    background: white;
    overflow: hidden;
    position: relative;
    padding: 30px 40px;
}

.widget.mobile .info_container > .modal_wrapper {
    display: flex;
}

.widget.mobile .info_container > .modal_wrapper > .modal_container {
    width: 90%;
    height: auto;
    margin: auto;
    padding: 5px;
}

.info_container > .modal_wrapper > .modal_container > .close_button {
    position: absolute;
    right: 0px;
    top: 0px;

    border: none;
    background: #fc5a0a;
    color: white;
    cursor: pointer;
    font-size: 12pt;
    padding: 6px 10px;
    opacity: 0.8;
}

.info_container > .modal_wrapper > .modal_container > .close_button:hover {
    opacity: 1;
}
</style>
